export default __webpack_public_path__ + "static/media/service-request-dashboard.188dc657.png";